import { useApiClient } from "@/api/client";
import SegmentDO = App.Data.Segments.SegmentDO;
import useToast from "@/ui/composables/useToast";

const client = useApiClient("segments");

export async function downloadSegmentData(
	segment: SegmentDO,
	format: "csv" | "xlsx",
	date?: string
) {
	const response = await client.downloadSegment(segment, {
		date: date ?? undefined,
		format,
	});

	if (response.isErr()) {
		useToast().error("Sorry something went wrong...", {
			timeout: 5000,
		});
	}
}
